import { AppStore } from '../stores/app.store';

export type AppContextType = {
  appStore: AppStore;
};

export enum RoleEnum {
  OWNER = 'OWNER',
  MANAGER = 'MANAGER',
  EMPLOYEE = 'EMPLOYEE'
}

export type FormStatusType = 'ADD' | 'EDIT' | 'DISABLE';
